import React from 'react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import loader from './chat-typing.gif';
import styles from './BotLoader.module.scss';

const BotLoader = () => {
  return (
    <div className={styles['bot-loader']}>
      {/* <div className={styles['profile-image']}>
        <SvgWithBranding type="chat_bot" className={styles.svg} />
      </div> */}
      <img src={loader} alt="Animated gif" className={styles.loader} />
    </div>
  );
};

export default BotLoader;
